import { styled, Flex, $fontSize } from "@acko-tech/building-blocks.ui.common";
import { ButtonText } from "@acko-tech/building-blocks.ui.button-old";
import { $pixelSizesUtilObj } from "@components/car/journey/mobile/styles";

export const Hyperlink = styled(ButtonText)`
  font-weight: 500;
  font-size: ${$fontSize.xs}
  line-height: ${$pixelSizesUtilObj[20]};
  color: #1b73e8;
  width: max-content;
  display: inline-block;
`;

export const StickyWrapper = styled(Flex)`
  width: 100%;
  background: white;
  position: fixed;
  bottom: 0;
  padding: 14px 0px;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);
  justify-content: center;
`;

export const Wrapper = styled(Flex)`
  width: ${props => props.width || "800px"};
  justify-content: flex-end;
`;

export const Container = styled(Flex)`
  width: 68%;
  display: flex;
  justify-content: ${props =>
    props.hidePriceSection ? "flex-end" : "space-between"};

  align-items: center;
`;
export const PriceText = styled.div`
  font-weight: 700;
  font-size: ${$pixelSizesUtilObj[22]};
  color: #282e33;
`;
